import { render } from "./SubscriberComponent.vue?vue&type=template&id=f79c6854"
import script from "./SubscriberComponent.vue?vue&type=script&lang=js"
export * from "./SubscriberComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/subscribers/SubscriberComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f79c6854"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f79c6854', __exports__)) {
    api.reload('f79c6854', __exports__)
  }
  
  module.hot.accept("./SubscriberComponent.vue?vue&type=template&id=f79c6854", () => {
    api.rerender('f79c6854', render)
  })

}


export default __exports__